import { AnimatePresence, motion } from "framer-motion";
import { useContext, useEffect, useMemo } from "react";
import sortExamList from "../../../Util/functions/ExamCreatorHelperFunctions/sortExamList";
import addHeadersToExamArray from "../../../Util/functions/ExamCreatorHelperFunctions/addHeadersToExamArray";
import { ExamCreatorContext } from "../../../Util/contexts/ExamCreatorContext";
import filterExamList from "../../../Util/functions/ExamCreatorHelperFunctions/filterExamList";
import { examCreatorListMotionProps } from "../../../Util/animations/Animations_v2";
import ExamListLoader from "./ExamListLoader";
import SectionHeader from "./SectionHeader";
import IncompleteExamListCard from "./IncompleteExamListCard";
import { AppContext } from "../../../Util/contexts/AppContext";

const IncompleteExamList = ({ selectedExamId, setSelectedExamId }) => {
  const { userData } = useContext(AppContext);
  const { loadingExamList, incompleteExams } = useContext(ExamCreatorContext);
  console.log("Incomplete exams", incompleteExams);
  useEffect(() => {
    document.getElementById("caseListBodyPageWrapper").scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      key={"Incomplete Exam List Body"}
      {...examCreatorListMotionProps(userData.AnimationsDisabled)}
    >
      <AnimatePresence mode="wait">
        {loadingExamList ? (
          <ExamListLoader />
        ) : (
          <AnimatePresence mode="wait">
            <motion.div
              className="examListVerticalContainer"
              {...examCreatorListMotionProps(userData.AnimationsDisabled)}
              key={"CaseListIncompleteCardContainer"}
            >
              <SectionHeader
                headerText={"Incomplete exams"}
                type={"logoText"}
              />
              <div
                className="examListVertical"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  width: "100%",
                }}
              >
                {incompleteExams.map((value, index) =>
                  value.type ? (
                    <></>
                  ) : (
                    <div
                      key={`Incomplete Exam Card - ${
                        value.ExamId || value.examId
                      } - ${index}`}
                      style={{
                        width: "100%",
                        marginBottom: "4px",
                      }}
                    >
                      <IncompleteExamListCard
                        selectedExamId={selectedExamId}
                        setSelectedExamId={setSelectedExamId}
                        examData={value}
                      />
                    </div>
                  )
                )}
              </div>
              {incompleteExams.length === 0 && (
                <div className="caseListNoCasesContainer">
                  <h3 className="caseListCaseTitle caseListNoCasesTitle">
                    No Incomplete Exams Found
                  </h3>
                  <p className="caseListCaseDiagnosisText caseListNoCasesText">
                    Great job! You don't have any incomplete exams at the
                    moment. All your started exams have been completed. Try
                    starting a new exam to see incomplete attempts here.
                  </p>
                </div>
              )}
            </motion.div>
          </AnimatePresence>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default IncompleteExamList;
